// extracted by mini-css-extract-plugin
export default {"wrapper":"seq-milestone-list_wrapper__te6zU","milestoneItem":"seq-milestone-list_milestoneItem__4W9QO","milestoneItemActive":"seq-milestone-list_milestoneItemActive__tnv2T"};